import { render, staticRenderFns } from "./v-pill-shape-form-input.vue?vue&type=template&id=65c7e89c&scoped=true"
import script from "./v-pill-shape-form-input.vue?vue&type=script&lang=js"
export * from "./v-pill-shape-form-input.vue?vue&type=script&lang=js"
import style0 from "./v-pill-shape-form-input.vue?vue&type=style&index=0&id=65c7e89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7e89c",
  null
  
)

export default component.exports